import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProviderImageComponent } from './provider-image.component';

@NgModule({
  declarations: [ProviderImageComponent],
  imports: [CommonModule],
  exports: [ProviderImageComponent],
})
export class ProviderImageModule {}
